<template>
  <div class="container">
    <BaseFrame
      @setAble="setAble"
      :able="able"
      saveText='保存'
      @save='submit("asseetsForm")'
      @cancel="$router.push({ name: 'assetsList' })"
      :infosArr="infosArr"
      :logText="logText"
      @hanldeLog="handleLog"
      :logData="logData"
      clearText=""
    >
      <div slot="content">
        <lk-form
          :model="asseetsForm"
          label-position="right"
          :label-width="130"
          ref="asseetsForm"
          :rules="ruleValidate"
        >
          <div class="cardContainer">
            <lk-card
              :title="(asseetsForm.category === 3 || $route.params.type === 'metering') ? '计量设备信息' : (asseetsForm.category === 4 || $route.params.type === 'cold' ? '冷藏储存设备信息' : '普通设备信息')">
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="设备类型:" prop="typeId" key="1">
                    <lk-select
                      clearable
                      v-if="able"
                      v-model.trim="asseetsForm.typeId"
                      @on-change="textChange"
                      :disabled="showDisabled">
                      <lk-option v-for="item in typeList" :key="item.id" :value="item.id">
                        {{item.name}}
                      </lk-option>
                    </lk-select>
                    <span v-else>
                      {{getTypeName(asseetsForm.typeId)}}
                    </span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2">
                  <lk-form-item label="设备编码:" prop="assertsCode" key="2">
                    <lk-input
                      :maxlength='10'
                      placeholder='请输入'
                      :clearable="!showDisabled"
                      v-if="able"
                      v-model.trim="asseetsForm.assertsCode"
                      :disabled="showDisabled">
                    </lk-input>
                    <span v-else>{{asseetsForm.assertsCode}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="名称:" prop="name" key="3">
                    <lk-input
                      :maxlength='20'
                      placeholder='请输入'
                      clearable v-if="able"
                      v-model.trim="asseetsForm.name">
                    </lk-input>
                    <span v-else>{{asseetsForm.name}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2">
                  <lk-form-item label="使用状态:" prop="status" key="4">
                    <lk-select v-if="able" v-model="asseetsForm.status" @on-change="statusInfo">
                      <lk-option v-for="(item, index) in assetsStatus" :key="index" :value="index + 1">
                        {{item}}
                      </lk-option>
                    </lk-select>
                    <span v-else>{{assetsStatus[asseetsForm.status - 1]}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="生产企业:" prop="manufacturer" key="5">
                    <lk-input :maxlength='100' placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.manufacturer"></lk-input>
                    <span v-else style="display: flex; line-height: 16px; padding-top: 7px;">{{asseetsForm.manufacturer}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2" v-if="$route.name === 'assetsMeteringAdd' || asseetsForm.category === 3  || asseetsForm.category === 4">
                  <lk-form-item label="设备型号:" prop="unitType" key="6">
                    <lk-input :maxlength='20' placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.unitType"></lk-input>
                    <span v-else>{{asseetsForm.unitType}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2" v-else>
                  <lk-form-item label="使用期限(月):" prop="serviceLife" :key="32">
                    <lk-input-number style="width: 100%;" :min="1" :max="9999999999" :precision="0" placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.serviceLife"></lk-input-number>
                    <span v-else>{{asseetsForm.serviceLife}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="购置价格:" prop="acquisitionPrice" key="7">
                    <lk-input-number style="width: 100%;" :precision="2" :min="0.01" :max="9999999999.99" :active-change="false" placeholder='请输入' :clearable="!showDisabled" v-if="able" v-model.trim="asseetsForm.acquisitionPrice" :disabled="showDisabled"></lk-input-number>
                    <span v-else>{{asseetsForm.acquisitionPrice}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2">
                  <lk-form-item label="购置时间:" prop="acquisitionTime" key="8">
                    <timeStampDatePicker  :options='disableFromNowAfter' placeholder='请输入' style="width:100%" v-if="able" v-model.trim="asseetsForm.acquisitionTime"></timeStampDatePicker>
                    <span v-else>{{asseetsForm.acquisitionTime|formatDate}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <template v-if="$route.name !== 'assetsMeteringAdd' && asseetsForm.category !== 3 && asseetsForm.category !== 4">
                <lk-row :gutter="16">
                  <lk-col span="10">
                    <lk-form-item label="养护人员:" key="21">
                      <lk-select clearable v-if="able" v-model.trim="asseetsForm.curingUserId">
                        <lk-option v-for="item in storeUserList" :key="item.id" :value="item.id">
                          {{item.name}}
                        </lk-option>
                      </lk-select>
                      <span v-else>{{asseetsForm.curingUserName}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="10" offset="2">
                    <lk-form-item label="养护周期(天):" prop="curingCycle" key="22">
                      <lk-input-number style="width: 100%;" :min="1" :max="9999" :precision="0" placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.curingCycle"></lk-input-number>
                      <span v-else>{{asseetsForm.curingCycle}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </template>
              <template v-if="$route.name === 'assetsMeteringAdd' || asseetsForm.category === 3 || asseetsForm.category === 4">
                <lk-row :gutter="16">
                  <lk-col span="10">
                    <lk-form-item label="折旧期限(月):" prop="carryForwardCycle" :key="31">
                      <lk-input-number style="width: 100%;" :min="1" :max="9999999999" :precision="0" placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.carryForwardCycle" :disabled="showDisabled"></lk-input-number>
                      <span v-else>{{asseetsForm.carryForwardCycle}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="10" offset="2">
                    <lk-form-item label="使用期限(月):" prop="serviceLife" :key="32">
                      <lk-input-number style="width: 100%;" :min="1" :max="9999999999" :precision="0" placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.serviceLife"></lk-input-number>
                      <span v-else>{{asseetsForm.serviceLife}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter="16" v-if="$route.params.type === 'metering' || asseetsForm.category === 3">
                  <lk-col span="10">
                    <lk-form-item label="测量范围:" prop="measuringRange" :key="33">
                      <lk-input :maxlength='50' placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.measuringRange"></lk-input>
                      <span v-else>{{asseetsForm.measuringRange}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="10" offset="2">
                    <lk-form-item label="测量精度:" prop="measurementAccuracy" :key="34">
                      <lk-input :maxlength='50' placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.measurementAccuracy"></lk-input>
                      <span v-else>{{asseetsForm.measurementAccuracy}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter="16">
                  <lk-col span="10">
                    <lk-form-item label="检测时间:" prop="firstInspectionTime" :key="35">
                      <timeStampDatePicker :options='disableFromNowAfter' placeholder='请输入' style="width:100%" v-if="able" v-model.trim="asseetsForm.firstInspectionTime"></timeStampDatePicker>
                      <span v-else>{{asseetsForm.firstInspectionTime|formatDate}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="10" offset="2">
                    <lk-form-item label="检测周期(天):" prop="detectionCycle" :key="36">
                      <lk-input-number  style="width:100%;" :min="1" :max="9999999999" :precision="0" placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.detectionCycle"></lk-input-number>
                      <span v-else>{{asseetsForm.detectionCycle}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </template>
              <lk-row :gutter="16">
                <lk-col span="10" v-if="$route.name === 'assetsMeteringAdd' || asseetsForm.category === 3 || asseetsForm.category === 4">
                  <lk-form-item label="检测机构:" prop="firstInspectionMechanism" :key="37">
                    <lk-input :maxlength='100' placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.firstInspectionMechanism"></lk-input>
                    <span v-else>{{asseetsForm.firstInspectionMechanism}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" v-if="$route.name !== 'assetsMeteringAdd' && asseetsForm.category !== 3 && asseetsForm.category !== 4">
                  <lk-form-item label="放置地点:" prop="placement" :key="38">
                    <lk-input :maxlength='20' placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.placement"></lk-input>
                    <span v-else>{{asseetsForm.placement}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2">
                  <lk-form-item label="折旧期限(月):" prop="carryForwardCycle" v-if="$route.name !== 'assetsMeteringAdd' && asseetsForm.category !== 3  && asseetsForm.category !== 4" key="31">
                    <lk-input-number style="width: 100%;" :min="1" :max="9999999999" :precision="0" placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.carryForwardCycle" :disabled="showDisabled"></lk-input-number>
                    <span v-else>{{asseetsForm.carryForwardCycle}}</span>
                  </lk-form-item>
                  <lk-form-item label="检测报告有效期:" v-if="$route.name === 'assetsMeteringAdd' || asseetsForm.category === 3 || asseetsForm.category === 4" prop="inspectionExpiryTime" :key="21">
                    <expire-picker :options='disableFromNow' :able='true' v-if="able" type="2" v-model.trim="asseetsForm.inspectionExpiryTime"/>
                    <span v-else>{{asseetsForm.inspectionExpiryTime|formatDate}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row>
                <lk-col span="10">
                  <lk-form-item label="检定或验证报告:" v-if="$route.name === 'assetsMeteringAdd' || asseetsForm.category === 3 || asseetsForm.category === 4" :key="21" prop="inspectionUrl">
                    <Uploader :able='able' v-model.trim="asseetsForm.inspectionUrl">
                      </Uploader>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16" v-if="$route.name === 'assetsMeteringAdd' || asseetsForm.category === 3 || asseetsForm.category === 4">
                <lk-col span="10">
                  <lk-form-item label="放置地点:" prop="placement" key="38">
                    <lk-input :maxlength='100' placeholder='请输入' clearable v-if="able" v-model.trim="asseetsForm.placement"></lk-input>
                    <span v-else>{{asseetsForm.placement}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2">
                  <lk-form-item label="养护人员:" v-if="$route.name === 'assetsMeteringAdd' || asseetsForm.category === 3 || asseetsForm.category === 4" :key="21">
                    <lk-select clearable v-if="able" v-model.trim="asseetsForm.curingUserId">
                      <lk-option v-for="item in storeUserList" :key="item.id" :value="item.id">
                        {{item.name}}
                      </lk-option>
                    </lk-select>
                    <span v-else>{{asseetsForm.curingUserName}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="用途描述:" key="39">
                    <lk-input :maxlength='100' placeholder='请输入' clearable v-if="able" type="textarea"  v-model.trim="asseetsForm.purpose"></lk-input>
                    <span v-else>{{asseetsForm.purpose}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" offset="2">
                  <lk-form-item label="备注:" key="40">
                    <lk-input :maxlength='100' placeholder='请输入' clearable v-if="able" type="textarea" v-model.trim="asseetsForm.description"></lk-input>
                    <span v-else>{{asseetsForm.description}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
        <div class="cardContainer" style="padding-top: 16px;" v-if="$route.name === 'assetsInfoCheck' && asseetsForm.category != 1">
          <lk-card title="养护记录">
            <lk-table v-if="asseetsForm.category === 2" border
                      :columns="assertsCuringColumns"
                      :data="assertsCuringTable"></lk-table>
            <lk-table v-if="asseetsForm.category === 3 || asseetsForm.category === 4" border
                      :columns="meteringAssertsCuringColumns"
                      :data="meteringAssertsCuringTable"></lk-table>
          </lk-card>
        </div>
      </div>
    </BaseFrame>
    <DTPModal
      v-model="statusClear"
      @confirm='confirmStatus'
      @handleCancel='cacelStatus'
      content='使用状态一旦更改为报废状态，则无法再次变更，确定操作吗?'
    ></DTPModal>
  </div>

</template>

<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import assets from '../../services/assets';
import system from '../../services/system';
import utils from '../../libs/utils';
import DTPModal from '../../components/DTPModal.vue';
import ExpirePicker from '../../components/expireInfo/expirePicker.vue';
import Uploader from '../../components/Uploader.vue';

export default {
  data() {
    return {
      tempTime: 0,
      disableFromNow: {
        disabledDate(date) {
          return date && date.valueOf() <= Date.now() - 86400000;
        },
      },
      disableFromNowAfter: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
      able: true,
      statusClear: false,
      showDisabled: false, // 修改的时候 设备类型、设备编码、购置价格、折旧期限不可用
      logText: '',
      logData: [],
      infosArr: [],
      tempStatus: '',
      asseetsForm: {
        id: '',
        status: '', // 使用状态
        category: '', // 设备大类 大类，1:办公设备，2:药品养护设备，3:计量设备，4:冷藏储存设备
        typeId: '', // 设备类型
        assertsCode: '', // 设备编号
        name: '', // 设备名称
        manufacturer: '', // 生产厂家
        unitType: '', // 设备型号
        serviceLife: 60, // 使用期限
        acquisitionPrice: 0.01, // 购置价格
        carryForwardCycle: 36, // 折旧期限(结转期限)
        curingUserId: '', // 养护人员
        curingUserName: '',
        curingCycle: 1, // 养护周期
        placement: '', // 放置地点
        purpose: '', // 用途描述
        description: '', // 备注
        acquisitionTime: null, // 购置时间

        // 计量设备
        measuringRange: '', // 测量范围
        measurementAccuracy: '', // 测量精度
        firstInspectionTime: null, // 首检时间
        detectionCycle: 365, //  检测周期
        firstInspectionMechanism: '', // 检测机构
      },
      assetsStatus: ['在用', '停用', '封存', '报废'],
      ruleValidate: {
        name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' },
        ],
        status: [
          {
            required: true, message: '请选择使用状态', type: 'number', trigger: 'change',
          },
        ],
        typeId: [
          {
            required: true, message: '请选择设备类型', type: 'number', trigger: 'change',
          },
        ],
        assertsCode: [
          { required: true, message: '请输入设备编号', trigger: 'blur' },
          { validator: this.codeExistValidator, trigger: 'blur' },
        ],
        acquisitionPrice: [
          {
            required: true, type: 'number', message: '请输入购置价格', trigger: 'blur',
          },
        ],
        curingCycle: [
          {
            required: true, type: 'number', message: '请输入养护周期', trigger: 'blur',
          },
        ],
        acquisitionTime: [{
          required: true, message: '请输入购置时间', trigger: 'blur', type: 'number',
        }],
        serviceLife: [
          {
            required: true, type: 'number', message: '请输入使用期限', trigger: 'blur',
          },
        ],
        carryForwardCycle: [
          {
            required: true, message: '请输入折旧期限', trigger: 'change', type: 'number',
          },
          { validator: this.isNumber, trigger: 'blur' },
        ],
        firstInspectionTime: [
          {
            required: true, message: '请输入检测时间', trigger: 'blur', type: 'number',
          },
        ],
        detectionCycle: [
          {
            required: true, type: 'number', message: '请输入检测周期', trigger: 'blur',
          },
        ],
        measuringRange: [
          { required: true, message: '请输入测量范围', trigger: 'blur' },
        ],
        measurementAccuracy: [
          { required: true, message: '请输入测量精度', trigger: 'blur' },
        ],
        firstInspectionMechanism: [
          { required: true, message: '请输入检测机构', trigger: 'blur' },
        ],
        inspectionExpiryTime: [
          {
            required: true, message: '请选择检测报告有效期', trigger: 'change', type: 'number',
          },
        ],
        inspectionUrl: [
          { required: true, message: '请添加检定或验证报告', trigger: 'change' },
        ],
      },
      typeList: [],
      assertsCuringColumns: [
        {
          title: '养护时间',
          key: 'createTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.createTime)),
        },
        { title: '养护人', key: 'createUserName', minWidth: 116 },
        { title: '养护内容', key: 'curingContent', minWidth: 116 },
        { title: '养护结果', key: 'curingResult', minWidth: 116 },
      ],
      assertsCuringTable: [],
      meteringAssertsCuringColumns: [
        {
          title: '养护时间',
          key: 'createTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.createTime)),
        },
        { title: '养护人', key: 'createUserName', minWidth: 116 },
        { title: '检测机构', key: 'inspectionMechanism', minWidth: 116 },
        { title: '检测结果', key: 'inspectionResultStr', minWidth: 116 },
        { title: '备注', key: 'curingDescription', minWidth: 116 },
        { title: '下次检测时间', key: 'nextTime', minWidth: 116 },
      ],
      meteringAssertsCuringTable: [],
      curingUserList: [],
      assertsStatusChangeLogsInfo: [],
      storeUserList: [],
      userMap: {},
    };
  },
  methods: {
    // 回显设备类型
    getTypeName(id) {
      if (!id) {
        return '';
      }
      const typeNames = [];
      this.typeList.forEach((item) => {
        if (item.id === id) {
          typeNames.push(item.name);
        }
      });
      return typeNames.join(',');
    },
    // 设备类型
    getTypeList(flag) { // 查看设备信息的时候，应该显示所有的类型
      const params = {
        status: flag ? 1 : '', // '': 所有 1: 启用 2: 禁用
        categories: [1, 2], // [1,2]普通设备, 3计量设备
      };
      if (this.asseetsForm.category === 3 || this.$route.params.type === 'metering') {
        params.categories = [3];
      } else if (this.asseetsForm.category === 4 || this.$route.params.type === 'cold') {
        params.categories = [4];
      }
      assets.typeList(params).then((res) => {
        if (res.data.status === 200) {
          this.typeList = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getInfos(id) {
      return new Promise((resolve) => {
        assets.assetsInfo({ id }).then((res) => {
          if (res.data.status === 200) {
            const tempData = res.data.data;
            // tempData.asserts.acquisitionTime = utils.exchangeTime(tempData.asserts.acquisitionTime);
            // tempData.asserts.firstInspectionTime = utils.exchangeTime(tempData.asserts.firstInspectionTime);

            this.tempStatus = tempData.asserts.status;
            if (!tempData.asserts.carryForwardCycle) {
              tempData.asserts.carryForwardCycle = '';
            }
            if (!tempData.asserts.serviceLife) {
              tempData.asserts.serviceLife = '';
            }
            this.asseetsForm = tempData.asserts;
            this.asseetsForm.lastCode = this.asseetsForm.assertsCode;
            if (this.asseetsForm.category === 2) {
              this.assertsCuringTable = [];
              this.assertsCuringTable = tempData.assertsCuringHistories;
            } else {
              this.meteringAssertsCuringTable = [];
              tempData.assertsCuringHistories.forEach((item) => {
                item.nextTime = utils.exchangeTime(item.inspectionTime
                  + this.asseetsForm.detectionCycle * 24 * 3600 * 1000);
              });
              this.meteringAssertsCuringTable = tempData.assertsCuringHistories;
            }
            this.assertsStatusChangeLogsInfo = [];
            this.assertsStatusChangeLogsInfo = tempData.assertsStatusChangeLogs;

            this.infosArr.push(
              { name: '门店名称:', value: tempData.asserts.storeName },
              { name: '录入人:', value: tempData.asserts.createUserName },
            );
            if (this.$route.name === 'assetsInfoCheck') {
              this.infosArr.push({ name: '使用状态:', value: this.assetsStatus[this.tempStatus - 1] });
            }
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    setAble(val) { // frame判定框架是否支持录入
      this.able = val;
    },
    submit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          const tempAcquisitionPrice = this.asseetsForm.acquisitionPrice;
          if (!this.asseetsForm.curingUserId && this.asseetsForm.curingUserName) {
            delete this.asseetsForm.curingUserName;
          }
          const request = utils.deepClone(this.asseetsForm);
          if (request.acquisitionTime) {
            request.acquisitionTime = (new Date(request.acquisitionTime)).getTime();
          }
          if (request.firstInspectionTime) {
            request.firstInspectionTime = (new Date(request.firstInspectionTime)).getTime();
          }
          if (this.$route.name === 'assetsInfoEdit') {
            assets.assetsUpdate(request).then((res) => {
              if (res.data.status === 200) {
                this.$Message.success('保存成功');
                setTimeout(() => {
                  this.$router.push({ name: 'assetsList' });
                }, 1000);
              } else {
                this.asseetsForm.acquisitionPrice = tempAcquisitionPrice;
                this.$Message.error(res.data.error);
              }
            }).catch((err) => {
              this.asseetsForm.acquisitionPrice = tempAcquisitionPrice;
              utils.handleError(err);
            });
          } else {
            assets.assetsSave(request).then((res) => {
              if (res.data.status === 200) {
                this.$Message.success('保存成功');
                setTimeout(() => {
                  this.$router.push({ name: 'assetsList' });
                }, 1000);
              } else {
                this.asseetsForm.acquisitionPrice = tempAcquisitionPrice;
                this.$Message.error(res.data.error);
              }
            }).catch((err) => {
              this.asseetsForm.acquisitionPrice = tempAcquisitionPrice;
              utils.handleError(err);
            });
          }
        } else {
          this.$Message.error('请按照要求填写!');
        }
      });
    },
    handleLog() {
      this.logData = [];
      this.assertsStatusChangeLogsInfo.forEach((item, index) => {
        let type = 2;
        if (index === this.assertsStatusChangeLogsInfo.length - 1) {
          type = 1;
        }
        this.logData.push({
          createTime: item.createTime,
          createUserName: item.createUserName,
          operateList: [{
            newValue: item.afterStatusStr,
            oldValue: item.beforeStatusStr,
            content: `${item.createUserName}操作`,
          }],
          type,
        });
      });
    },
    textChange(val) {
      this.typeList.forEach((item) => {
        if (item.id === val) {
          this.asseetsForm.category = item.category;
        }
      });
    },
    statusInfo() {
      if (this.asseetsForm.status === 4) {
        this.statusClear = true;
      }
    },
    confirmStatus() {
      this.statusClear = false;
    },
    cacelStatus() {
      this.asseetsForm.status = this.tempStatus;
      this.statusClear = false;
    },
    codeExistValidator(rule, value, callback) {
      this.$store.commit('setDisableLoading', true);
      assets.isAssertsCodeExist({ code: value }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data) {
            if (value === this.asseetsForm.lastCode) {
              callback();
            } else {
              callback(new Error('设备编码已存在.'));
            }
          } else {
            callback();
          }
        } else {
          this.$Message.error(res.data.error);
          callback();
        }
      }).catch((err) => {
        utils.handleError(err);
        callback();
      });
    },
    isNumber(rule, value, callback) {
      if (!value || utils.forbiddenDate.signlessIntegerValidator(value)) {
        callback();
      } else {
        callback(new Error('请输入整数.'));
      }
    },
    getUserList() {
      system.getStoreUserList({}).then((res) => {
        if (res.data.status === 200) {
          this.users = [];
          res.data.data.list.forEach((item) => {
            const user = {};
            user.id = item.sysUser.id;
            user.name = item.sysUser.name;
            this.userMap[user.name] = user.id;
            this.storeUserList.push(user);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    setFormValidaterRules(needReset = false) {
      if (!(this.$route.params.type === 'cold' || this.asseetsForm.category === 4)) {
        return;
      }
      const formKeys = ['acquisitionPrice', 'carryForwardCycle', 'acquisitionTime', 'serviceLife'];
      const rules = this.ruleValidate;
      formKeys.forEach((item) => {
        rules[item] && rules[item].forEach((child) => {
          if (child.required) {
            child.required = false;
          }
        });
      });
      this.$set(this.ruleValidate, rules);
      if (needReset) {
        this.$refs.asseetsForm.fields.forEach((field) => {
          field.setRules();
        });
      }
    },
  },
  created() {
    this.getUserList();
    if (this.$route.name !== 'assetsCommonAdd' && this.$route.name !== 'assetsMeteringAdd') {
      this.getInfos(this.$route.params.id).then(() => {
        this.getTypeList();
        this.setFormValidaterRules(true);
      });
      this.showDisabled = true;
      this.logText = '操作日志';
    } else {
      this.getTypeList(true);
      this.setFormValidaterRules();
    }
  },
  beforeRouteEnter: (to, from, next) => {
    if (to.params.type) {
      if (to.params.type === 'cold') {
        to.meta.subTitle = '新建冷藏储存设备';
      } else {
        to.meta.subTitle = '新建计量器具';
      }
    }
    next();
  },
  components: {
    BaseFrame,
    DTPModal,
    ExpirePicker,
    Uploader,
  },
};
</script>

<style scoped>

</style>
